import type { PipeTransform } from '@angular/core';
import { inject, Pipe } from '@angular/core';
import { ElapsedTimeService } from '../services/elapsed-time.service';

@Pipe({
  name: 'elapsedTime',
  pure: false, // kell, mert a service now() signaljától is függ
})
export class ElapsedTimePipe implements PipeTransform {
  private readonly elapsedTimeService = inject(ElapsedTimeService);

  transform(startIso: string, toIso: string | null = null): string {
    return this.elapsedTimeService.elapsed(startIso, toIso);
  }
}
